import { cn } from '@/lib/utils';
import { SelectableColors } from '@/types/content';
import React from 'react';

interface LabelProps {
  label: string;
  color?: SelectableColors;
  bold?: boolean;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const Label = ({ label, color, bold, attributes }: LabelProps) => {
  const { key, ...rest } = attributes ?? {};

  const colorClass = cn(
    color === "brand" ? "text-brand" : 
    color === "primary" ? "text-foreground" : 
    color === "secondary" ? "text-muted-foreground" : 
    "text-brand",
  );
  const boldClass = bold ? "font-bold" : "font-normal";

  return (
    <div
      key={key}
      {...rest}
      className="content-label"
    >
      <h6 className={`label ${colorClass} ${boldClass}`}>
        {label}
      </h6>
    </div>
  );
}; 